// extracted by mini-css-extract-plugin
export default {"button":"styles_button__8gcTa","primary":"styles_primary__55hAm","secondary":"styles_secondary__RfSvi","tirtiary":"styles_tirtiary__Dr2fD"};